var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDailyRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.366,
    height: 55.462,
    viewBox: "0 0 41.366 55.462",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#7c8ebc;}.b{fill:#fc6c1c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M63.346,34.932v29.68H45.327V34.932a5.682,5.682,0,0,1,5.681-5.681h6.658A5.682,5.682,0,0,1,63.346,34.932Z",
    transform: "translate(-21.98 -7.15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M62.045,15.2a7.483,7.483,0,1,1-14.967,0v-2.02H62.045Z",
    transform: "translate(-22.205 -1.272)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.259,30.324l-3.276.561-1.13-1.428-6.4,1.1.37,1.558-3.278.561L27.008,49.54,40.725,47.19ZM27.1,46.1,20.991,33.923l10.364-1.776,6.113,12.179Z",
    transform: "translate(-18.542 -7.177)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.047,37.75l-7.162,1.227-.336-.669,7.163-1.227Z",
    transform: "translate(-19.313 -8.156)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.015,39.679l-7.162,1.226-.336-.669,7.162-1.226Z",
    transform: "translate(-19.437 -8.403)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.983,41.607,26.82,42.835l-.336-.669,7.162-1.227Z",
    transform: "translate(-19.561 -8.651)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M61.885,10.084H39.243V8.919H45.3A8.334,8.334,0,0,1,51.529,2a6.224,6.224,0,0,0-2.481,4.974h1.017a5.219,5.219,0,0,1,4.49-5.162A8.33,8.33,0,0,1,61.885,10.084Z",
    transform: "translate(-21.199 0.187)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyRound);
export default __webpack_public_path__ + "static/media/daily-round.2f3755d58f6639116b5591411fc7d71f.svg";
export { ForwardRef as ReactComponent };